/**
 * Represents the availability status of a [[Seat]].
 */
export var SeatAvailabilityStatus;
(function (SeatAvailabilityStatus) {
    /**
     * The [[Seat]] is available for selection.
     *
     * @remarks
     * When the seat availability request is associated with a [[StandardOrder]], any seats
     * reserved for the requested [[StandardOrder]] will appear as [[Available]].
     */
    SeatAvailabilityStatus["Available"] = "Available";
    /**
     * The [[Seat]] has been sold to another customer.
     *
     * @remarks
     * When the seat availability request is **not** associated with a [[StandardOrder]], any seats
     * reserved for a [[StandardOrder]] will appear as [[Sold]].
     */
    SeatAvailabilityStatus["Sold"] = "Sold";
    /**
     * The [[Seat]] has been marked as broken and is unavailable for sale.
     */
    SeatAvailabilityStatus["Broken"] = "Broken";
    /**
     * The [[Seat]] has been reserved by the [[Site]] and is unavailable for sale.
     *
     * @remarks
     * Commonly used to prevent the sale of a seat, either for business or social distance seating purposes.
     *
     * If social distance seating is enabled and the seat availability request is associated with a [[StandardOrder]],
     * any seats pre-blocked by the social distance seating rules will appear as [[House]].
     */
    SeatAvailabilityStatus["House"] = "House";
})(SeatAvailabilityStatus || (SeatAvailabilityStatus = {}));
//# sourceMappingURL=seat-availability-status.js.map